import { get } from "svelte/store";
import * as AuthApi from "../../apiLoader/auth";
import { NavigationType, sessionStore, updateSession } from "../../stores/session";
import type { AuthData } from "../auth/auth";
import { getFingerprint } from "../../public/lib/helpers/fingerprint";
import { settingsStore } from "../../stores/settings";
import { navigateTo } from "../../routing";
import { getSearchParam, removeSearchParam } from "../document";
import { saveUserSettings } from "../../apiLoader/user";
import { jwtDecode } from "jwt-decode";

export class SecondaryAuthFlow {
  async start(channel: string) {
    updateSession({ isAuthenticating: true });
    const session = get(sessionStore);
    const settings = get(settingsStore);
    const returnTo = `${document.location.origin}${document.location.pathname}`;

    const data: AuthData = {
      return_to: returnTo,
      fooji_data: {
        workflow_key: settings.workflow as string
      },
      client: "microsite",
      fingerprint: getFingerprint(),
      fingerprint_description: window.navigator.userAgent,
      language: session.language
    };
    try {
      const { redirect_url: redirectUrl, state } = await AuthApi.start(channel, data);
      updateSession({ authState: state });
      document.location.href = redirectUrl;
    } catch (e) {
      updateSession({ isAuthenticating: false });
      throw e;
    }
  }

  validateState() {
    const { authState } = get(sessionStore);
    if (!authState) {
      // google auth flow doesn't have a state
      return true;
    }
    const state = getSearchParam("state");

    if (state && authState && state === authState) {
      updateSession({ authState: undefined });
      return true;
    } else {
      updateSession({ isAuthenticating: false });
      throw new Error("Invalid state");
    }
  }

  async processJWT() {
    const jwt = getSearchParam("jwt");
    if (!jwt) {
      updateSession({ isAuthenticating: false });
      throw new Error("No JWT found in URL");
    }

    const jwtData: { id: number } = jwtDecode(jwt);
    await saveUserSettings({ secondary_channel_jwt: jwt, secondary_channel_user_id: jwtData?.id });
    removeSearchParam("jwt");
    return jwt;
  }

  async finish() {
    this.validateState();
    await this.processJWT();

    updateSession({ isAuthenticating: false });
    navigateTo(NavigationType.Next);
  }
}
